import { useState } from "react";

import HtmlTab from "./HtmlTab";

import ProductSpecifications from "./ProductSpecifications";

import DesktopTabs from "./DesktopTabs";

import MobileTabs from "./MobileTabs";
import "./ProductTabs.css";

const COMPONENTS = {
  html: HtmlTab,

  specifications: ProductSpecifications,
};

export default function ProductTabs({
  tabs,

  selectedVariation,
}) {
  const [active, setActive] = useState(0);

  const current = tabs[active];

  const Component = COMPONENTS[current.type];

  return (
    <div className="product-tabs-page">
      <DesktopTabs tabs={tabs} active={active} setActive={setActive} />

      <MobileTabs tabs={tabs} active={active} setActive={setActive} />

      <div className="tab-content-page">
        <Component
          html={current.content}
          productSpecifications={current.content}
          variationSpecifications={selectedVariation?.specifications}
        />
      </div>
    </div>
  );
}
